import React from "react";
import { GTM_ID } from "../utils/gtm";
export const GoogleTagManager = () => {
  return <noscript data-id="element-228">
      <iframe src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`} height="0" width="0" style={{
      display: "none",
      visibility: "hidden"
    }} data-id="element-229" />
    </noscript>;
};